import React, { Component } from "react";

class ChangePasswordConfirmation extends Component {
  render() {
    return (
      <section className="section auth">
        <div className="container">
          <h1>Cambiar contraseña</h1>
          <p>Su contraseña fue actualizada exitosamente!</p>
        </div>
        <div className="field">
              <p className="control">
                <a className="btn btn-primary" href="/login">INICIO DE SESION</a>
              </p>
            </div>
      </section>
    );
  }
}

export default ChangePasswordConfirmation;